import { Stack, Text, Title } from "@mantine/core";
import { useCounter, useTimeout } from "@mantine/hooks";
import { IconLock } from "@tabler/icons-react";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/_public/403")({
  component: RouteComponent
});

function RouteComponent() {
  const router = useRouter();
  const [count, { decrement }] = useCounter(5, { min: 0, max: 5 });

  const timer = useTimeout(() => {
    decrement();
  }, 1000);

  useEffect(() => {
    timer.start();

    if (count === 0) {
      router.history.back();
    }

    return () => timer.clear();
  }, [count]);

  return (
    <Stack className="min-h-dvh bg-gray-50 p-4" justify="center" align="center">
      <div className="flex w-full max-w-md flex-col items-center gap-6 rounded-2xl bg-white p-10 text-center shadow-md">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-red-100">
          <IconLock size={40} className="text-red-500" stroke={1.5} />
        </div>

        <div className="flex flex-col gap-2">
          <Title order={1} size={52} className="font-bold text-gray-800">
            403
          </Title>
          <Title order={2} size="h3" className="text-gray-700">
            Acesso Negado
          </Title>
          <Text c="dimmed" size="sm" className="mt-1">
            Você não tem permissão para acessar esta página.
          </Text>
        </div>

        <Text c="dimmed" size="sm">
          Redirecionando em {count} segundo{count !== 1 ? "s" : ""}...
        </Text>
      </div>
    </Stack>
  );
}
